import React from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';

const SuppressedNote = () => {
  const { t } = useTranslation();
  return (
    <div className="suppressedNote">
      <div className="iconImg">
        <img src="/content/images/icons/suppressedIcon.svg" alt="" />
      </div>
      <div className="headingLabel">
        {t(
          'This is a limited availability drug and is not available at most pharmacies'
        )}
      </div>
      <p>
        {t(
          'We recommend contacting your insurance company about the availability of this drug'
        )}
      </p>
    </div>
  );
};

export default SuppressedNote;
